/* eslint-disable no-plusplus */

export const findAvailableIndex = ({productID, index}, {products}) => {
    const {columns, resolution} = products[productID];
    const column = Math.floor(index / resolution);
    const {available} = columns[column];

    if (available === false) {
        for (let col = column - 1; col >= 0; col--) {
            const {available, start} = columns[col];

            if (available) return start;
        }

        for (let col = column + 1; col < columns.length; col++) {
            const {available, start} = columns[col];

            if (available) return start;
        }
    }

    return index;
};
